module.exports = __webpack_public_path__ + "img/lcs-letterhead-logo2-90x22.d4a9de63.png";